import { ConsultaModel } from './../../core/interfaces/consulta.model';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactService } from 'src/app/core/services/contact.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
})
export class ContactComponent implements OnInit {
  contactoForm: FormGroup;
  cargando = false;

  constructor(private contactService: ContactService) {
    this.contactoForm = new FormGroup({
      nombre: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
      texto: new FormControl('', Validators.required),
    });
  }

  ngOnInit(): void { }

  onSubmit() {
    this.cargando = true;

    let consulta: ConsultaModel = {
      name: this.contactoForm.get('nombre').value,
      email: this.contactoForm.get('email').value,
      text: 'De: ' + this.contactoForm.get('email').value + '<br><br>' + 'Mensaje: ' + this.contactoForm.get('texto').value,
    };
    this.contactService.enviarConsulta(consulta).subscribe(
      (resp) => {
        this.cargando = false;

        Swal.fire({
          title: 'Bien!',
          html: 'Se ha enviado su consulta. Nos pondremos en contacto contigo a la brevedad.',
          icon: 'success',
          confirmButtonText: 'CERRAR',
          customClass: { popup: 'contact_success' },
          timer: 4000,
        });

        this.contactoForm.reset();
      },
      (error) => {
        this.cargando = false;

        Swal.fire('Ups!', `Ha ocurrido un error al enviar la consulta. Intente nuevamente más tarde.`, 'error');
      },
    );
  }
}
